import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
import { GUID } from "./../../guid";

@Component({
  selector: "app-convertmappingfield",
  templateUrl: "./convertmappingfield.component.html",
  styleUrls: ["./convertmappingfield.component.scss"],
})
export class ConvertmappingfieldComponent implements OnInit {
  tabs = [];
  selectedTabIndex: number = 0;

  isLoading = false;
  isError = false;
  errorMessage = "";
  convertSettingId = "";
  ConvertionObjectMappingFieldId = "";
  convertSettingsJsontextId = "";
  convertSettingName = "";
  objectName = "";
  objectId = "";
  mode = "";
  fields = [];
  convertedFields = [];
  convertsettings: any;
  convertionobjectMapping = [];
  convertionobjectmappingField = [];
  savedFields = []; // Populate this with the saved fields

  outputFields: Array<any>;
  displayedColumns: string[] = ["inputobject", "targetobject"];
  dataSource: any[] = [];
  guid: GUID;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService
  ) {}
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.convertSettingId = this.route.snapshot.params.id;
      this.convertSettingName = this.route.snapshot.params.name;
      this.objectName = this.route.snapshot.params.objectname;
      this.objectId = this.route.snapshot.params.objectid;
    });

    // this.getConvertSettingsById();

    // this.getMetaFieldsForSelection().then(() => {
    this.getConvertSettingsById().then(() => {
      if (this.convertsettings.convertionobjectmappingfield.length > 0) {
        this.mode = "edit";
      } else {
        this.mode = "new";
      }
      console.log(
        "this.convertsettings",
        this.convertsettings.convertionobjectmappingfield
      );
      // this.convertsettings.convertionobjectmappingfield = this.savedFields;
      // this.populateFields();
    });
    // this.populateFields();

    // });
    // this.getConvertSettingsById2();

    this.getMetaFieldsForSelection().then(() => {
      this.populateFields();

    });
    this.guid = new GUID();
  }

  populateFields() {
    // alert("Hello! im working");
    console.log("savedField", this.savedFields);
    console.log("this.fields", this.fields);


    this.savedFields.forEach((savedField) => {
      const matchingField = this.fields.find(
        (field) => field.id === savedField.inputfieldid
      );
      if (matchingField) {
        matchingField.selectedValue = savedField.outputfieldid;
      }
      console.log("matchingField", matchingField);
    });
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  currentTab = "";
  // onTabChange() {
  //   // Alert the value of the selected tab

  //   const selectedTab = this.tabs[this.selectedTabIndex];
  //   // alert(selectedTab.outputobjectname);
  //   // alert(selectedTab.outputobjectid);
  //   this.currentTab = selectedTab.outputobjectname;
  //   return new Promise((resolve, reject) => {
  //     console.log("getMetaFieldsForSelection");

  //     var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

  //     let postOption = {
  //       organizationid: localStorage.getItem("crm_orgid"),
  //       userid: localStorage.getItem("crm_userid"),
  //       username: localStorage.getItem("crm_username"),
  //       // domain: localStorage.getItem("domain"),
  //       // subdomain: localStorage.getItem("subdomain"),
  //       domain: localStorage.getItem(
  //         `${localStorage.getItem("crm_orgid")}.domain`
  //       ),
  //       subdomain: localStorage.getItem(
  //         `${localStorage.getItem("crm_orgid")}.subdomain`
  //       ),
  //       profileid: userDetail.profileid,
  //       data: {
  //         metafield: {
  //           metaobjectid: selectedTab.outputobjectid,
  //           metaobjectname: selectedTab.outputobjectname,
  //         },
  //       },
  //     };

  //     console.log("postOption", postOption);

  //     this.isLoading = true;
  //     this.dataService.getMetaFieldsForSelection(postOption).subscribe(
  //       (res) => {
  //         console.log(res);
  //         if (res !== null && res.success == 1) {
  //           const fields = res.data.metafields;

  //           var fieldArr = [];
  //           //just add an empty entry sice this field is optional
  //           // objArr.push({ value: "", label: "--None--" });
  //           for (let i = 0; i < fields.length; i++) {
  //             fieldArr.push({
  //               value: fields[i].id,
  //               label: fields[i].labelname,
  //               fieldname: fields[i].fieldname,
  //             });
  //           }
  //           this.outputFields = fieldArr;

  //           //create fieldlist from fields as readable form by selection control
  //           // for (let i = 0; i < this.fields.length; i++) {
  //           //   var field = fields[i];

  //           //   //skip id type fields if there
  //           //   if (field.fieldtype.toLowerCase() == "id") continue;

  //           //   //skip fields with visibility false
  //           //   if (field.visible == false) continue;

  //           //   //skip fields deleted, ownertype etc.,
  //           //   if (
  //           //     field.fieldname.toLowerCase() == "deleted" ||
  //           //     field.fieldname.toLowerCase() == "ownertype" ||
  //           //     field.fieldname.toLowerCase() == "migrated" ||
  //           //     field.fieldname.toLowerCase() == "organizationid" ||
  //           //     field.fieldname.toLowerCase() == "search" ||
  //           //     field.fieldname.toLowerCase() == "date_range"
  //           //   )
  //           //     continue;

  //           //   //convert to titecase
  //           //   var strLabel = field.labelname;
  //           // }

  //           this.isLoading = false;
  //           resolve(null);
  //         } else {
  //           console.log("No fields data!");
  //           this.isLoading = false;
  //           resolve(null);
  //         }
  //       },
  //       (err) => {
  //         console.log("Error***:", err);
  //         this.errorMessage = err.message;
  //         this.isError = true;
  //         this.isLoading = false;
  //         resolve(null);
  //       }
  //     );
  //     this.getConvertSettingsById2();

  //     // this.getConvertSettingsById2().then(() => {
  //     //   console.log("this.convertsettings", this.convertsettings);
  //     //   // this.convertedFields =
  //     //   // const convertionobjectmapping = this.convertsettings.convertionobjectmappingfield
  //     //   // setTimeout(() => {
  //     //     console.log(this.outputFields);
  //     //     console.log(this.convertionobjectmappingField);

  //     //     const mappedGroupRowFields = this.convertionobjectmappingField.map(
  //     //       (mapfield) => {
  //     //         const fields = this.outputFields.map((field) => {
  //     //           // console.log(mapfield.outputfieldid);
  //     //           // console.log(field);
  //     //           // if (mapfield.outputfieldid == field.value) {
  //     //           //   this.convertedFields.push(mapfield);
  //     //           //   const objName = [{currentObjectname:"AdmissionCategory"}]
  //     //           //   this.convertedFields.push(...objName)
  //     //           // }
  //     //           if (mapfield.outputfieldid == field.value) {
  //     //             const convertedField = {
  //     //                 id: mapfield.id,
  //     //                 organizationid: mapfield.organizationid,
  //     //                 convertionobjectmappingid: mapfield.convertionobjectmappingid,
  //     //                 multifieldmapping: mapfield.multifieldmapping,
  //     //                 literals: mapfield.literals,
  //     //                 inputfieldid: mapfield.inputfieldid,
  //     //                 outputfieldid: mapfield.outputfieldid,
  //     //                 inputfieldname: mapfield.inputfieldname,
  //     //                 convertsettingid: mapfield.convertsettingid,
  //     //                 outputfieldname: mapfield.outputfieldname,
  //     //                 currentObjectname:  this.currentTab // Set the current object name here
  //     //             };
  //     //             // const convertedField = {
  //     //             //   value: mapfield.outputfieldid,
  //     //             //   label: "Additional Information",
  //     //             // };
  //     //             this.convertedFields.push(convertedField);
  //     //           }
  //     //         });
  //     //       }
  //     //     );
  //     //     console.log(this.convertedFields);
  //     //   // }, 100);
  //     // });
  //   });
  // }
  // Assuming you have a function to handle tab change events

  async onTabChange() {
    const selectedTab = this.tabs[this.selectedTabIndex];
    this.currentTab = selectedTab.outputobjectname;

    try {
      // Fetch metafields
      await this.fetchMetaFields(
        selectedTab.outputobjectid,
        selectedTab.outputobjectname
      );

      // Now that metafields are fetched, call getConvertSettingsById2
      await this.getConvertSettingsById2();

      // You can do further processing here if needed
    } catch (error) {
      console.error("Error while handling tab change:", error);
    }
  }

  async fetchMetaFields(metaobjectId: any, metaobjectname: any) {
    const userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    const postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      profileid: userDetail.profileid,
      data: {
        metafield: {
          metaobjectid: metaobjectId,
          metaobjectname: metaobjectname,
        },
      },
    };

    console.log("postOption", postOption);

    this.isLoading = true;
    return new Promise((resolve, reject) => {
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            const fields = res.data.metafields;

            // const fieldArr = fields.map((field) => ({
            //   value: field.id,
            //   label: field.labelname,
            //   fieldname: field.fieldname,
            // }));

            const noneField = {
              value: '',
              label: '--None--',
              fieldname: ''
            };
      
            // Map the fields and add the --None-- field at the beginning
            const fieldArr = [
              noneField,
              ...fields.map((field) => ({
                value: field.id,
                label: `${field.labelname}.${field.fieldname}`,
                fieldname: field.fieldname,
              }))
            ];

            this.outputFields = fieldArr;
            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  parentObjectChange(
    event: { value: string; label: any; fieldname: any },
    field: any,
    tab: any
  ) {
    console.log("parentObjectChange", event);
    // console.log("tab", tab);

    // if (event.value.trim() === "") {
    //   return;
    // }
    if (event.value.trim() != "") {

    // const isDuplicate = this.convertedFields.some(
    //   (entry) => entry.outputfieldid == event.value
    // );

    // if (isDuplicate) {
    //   field.isDuplicate = true;
    //   this.showWarning("Field already selected");
    //   // alert("Duplicate entry found. This field already Selected.");

    //   return;
    // } else {
    //   field.isDuplicate = false;
    // }
  }


    this.convertedFields = this.convertedFields.filter((entry) => {
      return (
        entry.inputfieldid !== field.id ||
        entry.currentObjectname !== this.currentTab
      );
    });

    // Add the new entry to the convertedFields array
    var changedFields = {
      inputfieldid: field.id,
      inputfieldname: field.fieldname,
      outputfieldid: event.value,
      outputfieldname: event.fieldname,
      currentObjectname: tab.outputobjectname,
      convertionobjectmappingid: tab.id,
    };
    this.convertedFields.push(changedFields);
    console.log(this.convertedFields);
    // this.outputFields = this.outputFields.filter(option => option.value !== event.value);
  }

  getConvertSettingsById() {
    return new Promise((resolve, reject) => {
      console.log("getConvertSettingsById");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          convertsetting: {
            id: this.convertSettingId,
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getConvertSettingsById(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res.success == 1) {
            // this.process = res.data.process;
            // console.log("Doneeee****", this.process);

            this.convertsettings = res.data.convertsettings;
            this.tabs = res.data.convertsettings.convertionobjectmapping;
            this.savedFields =
              res.data.convertsettings.convertionobjectmappingfield;
            console.log(this.savedFields);
            // if (this.folder != null) {
            //   this.dataSource = this.folder.map((folder) => ({
            //     id: folder.id,
            //     name: folder.name,
            //     // modifiedby: folder.modifiedby,
            //     // modifieddate: folder.modifieddate,
            //     createdby: folder.createdby,
            //     createddate: folder.createddate,
            //     parentid: folder.parentfolderid,
            //     // parentfoldername: this.parentfolderName,
            //   }));
            // }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("Error while Retrieving");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  // getConvertSettingsById2() {
  //   return new Promise((resolve, reject) => {
  //     console.log("getConvertSettingsById");

  //     let postOption = {
  //       organizationid: localStorage.getItem("crm_orgid"),
  //       data: {
  //         convertsetting: {
  //           id: this.convertSettingId,
  //         },
  //       },
  //     };
  //     console.log("postOption", postOption);
  //     this.isLoading = true;
  //     this.dataService.getConvertSettingsById(postOption).subscribe(
  //       (res) => {
  //         console.log("res", res);

  //         if (res.success == 1) {
  //           // this.process = res.data.process;
  //           // console.log("Doneeee****", this.process);

  //           this.convertsettings = res.data.convertsettings;
  //           this.convertionobjectMapping =
  //             res.data.convertsettings.convertionobjectmapping;
  //           this.convertionobjectmappingField =
  //             res.data.convertsettings.convertionobjectmappingfield;

  //           console.log(this.convertionobjectMapping);
  //           console.log(this.convertionobjectmappingField);

  //           // if (this.folder != null) {
  //           //   this.dataSource = this.folder.map((folder) => ({
  //           //     id: folder.id,
  //           //     name: folder.name,
  //           //     // modifiedby: folder.modifiedby,
  //           //     // modifieddate: folder.modifieddate,
  //           //     createdby: folder.createdby,
  //           //     createddate: folder.createddate,
  //           //     parentid: folder.parentfolderid,
  //           //     // parentfoldername: this.parentfolderName,
  //           //   }));
  //           // }

  //           this.isLoading = false;
  //           resolve(null);
  //         } else {
  //           console.log("Error while Retrieving");
  //           this.isLoading = false;
  //           resolve(null);
  //         }
  //       },
  //       (err) => {
  //         console.log("Error***:", err);
  //         this.errorMessage = err.message;
  //         this.isError = true;
  //         this.isLoading = false;
  //         resolve(null);
  //       }
  //     );
  //   });
  // }
  getConvertSettingsById2() {
    return new Promise((resolve, reject) => {
      console.log("getConvertSettingsById");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          convertsetting: {
            id: this.convertSettingId,
          },
        },
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getConvertSettingsById(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res.success == 1) {
            this.convertsettings = res.data.convertsettings;
            this.convertionobjectMapping =
              res.data.convertsettings.convertionobjectmapping;
            this.convertionobjectmappingField =
              res.data.convertsettings.convertionobjectmappingfield;

            console.log(this.convertionobjectMapping);
            console.log(this.convertionobjectmappingField);

            // Populate the outputFields array with appropriate values
            // const fieldArr = this.convertionobjectmappingField.map(
            //   (mapfield) => ({
            //     value: mapfield.outputfieldid,
            //     label: mapfield.outputfieldname,
            //   })
            // );

            console.log(this.outputFields);

            const mappedGroupRowFields = this.convertionobjectmappingField.map(
              (mapfield) => {
                const fields = this.outputFields.map((field) => {
                  // console.log(mapfield.outputfieldid);
                  // console.log(field);
                  // if (mapfield.outputfieldid == field.value) {
                  //   this.convertedFields.push(mapfield);
                  //   const objName = [{currentObjectname:"AdmissionCategory"}]
                  //   this.convertedFields.push(...objName)
                  // }
                  if (mapfield.outputfieldid == field.value) {
                    const convertedField = {
                      id: mapfield.id,
                      organizationid: mapfield.organizationid,
                      convertionobjectmappingid:
                        mapfield.convertionobjectmappingid,
                      multifieldmapping: mapfield.multifieldmapping,
                      literals: mapfield.literals,
                      inputfieldid: mapfield.inputfieldid,
                      outputfieldid: mapfield.outputfieldid,
                      inputfieldname: mapfield.inputfieldname,
                      convertsettingid: mapfield.convertsettingid,
                      outputfieldname: mapfield.outputfieldname,
                      currentObjectname: this.currentTab, // Set the current object name here
                    };
                    // const convertedField = {
                    //   value: mapfield.outputfieldid,
                    //   label: "Additional Information",
                    // };
                    this.convertedFields.push(convertedField);
                  }
                });
              }
            );
            console.log(this.convertedFields);
            // }, 100);
            // });
            // this.convertedFields = fieldArr;

            console.log(this.convertedFields);

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("Error while Retrieving");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getMetaFieldsForSelection() {
    return new Promise((resolve, reject) => {
      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: this.objectId,
            metaobjectname: this.objectName,
          },
        },
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.fields = res.data.metafields;

            //create fieldlist from fields as readable form by selection control
            for (let i = 0; i < this.fields.length; i++) {
              var field = this.fields[i];

              //skip id type fields if there
              if (field.fieldtype.toLowerCase() == "id") continue;

              //skip fields with visibility false
              if (field.visible == false) continue;

              //skip fields deleted, ownertype etc.,
              if (
                field.fieldname.toLowerCase() == "deleted" ||
                field.fieldname.toLowerCase() == "ownertype" ||
                field.fieldname.toLowerCase() == "migrated" ||
                field.fieldname.toLowerCase() == "organizationid" ||
                field.fieldname.toLowerCase() == "search" ||
                field.fieldname.toLowerCase() == "date_range"
              )
                continue;

              //convert to titecase
              var strLabel = field.labelname;
            }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }
  cancel(){
    this.router.navigateByUrl("/home/convertsettinglist");

  }

  save() {
    this.isLoading = false;
    this.isError = false;

    // if (this.detailForm.invalid) {
    //   this.errorMessage = "The fields [Label] and [Name] are mandatory.";
    //   return;
    // }

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new" || this.mode.toLowerCase() == "edit") {
      this.ConvertionObjectMappingFieldId = this.guid.getGUID(
        "convertionobjectmappingfield"
      );
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      data: {
        mode: this.mode,
        convertionobjectmappingfield: [],
        convertsettingsjsontext: [],
      },
    };

    var arrConvertionObjectMappingField = [];

    for (let convertionObjField of this.convertedFields) {
      if (
        this.mode.toLowerCase() == "new" ||
        this.mode.toLowerCase() == "edit" 
      ) {
        this.ConvertionObjectMappingFieldId =
          this.guid.getGUID("convertionobject");
      }
      if(convertionObjField.outputfieldname!=""){
      // console.log(convertionObjField);
      var convertionobjectmappingfield = {
        id: this.ConvertionObjectMappingFieldId,
        convertionobjectmappingid: convertionObjField.convertionobjectmappingid,
        convertsettingid: this.convertSettingId,
        multifieldmapping: false,
        literals: "",
        inputfieldid: convertionObjField.inputfieldid,
        inputfieldname: convertionObjField.inputfieldname,
        outputfieldid: convertionObjField.outputfieldid,
        outputfieldname: convertionObjField.outputfieldname,
        // outerjoin: reportTypeRelation.outerjoin,
      };
      arrConvertionObjectMappingField.push(convertionobjectmappingfield);
    }
  }

    postOption.data.convertionobjectmappingfield =
      arrConvertionObjectMappingField;

    this.convertSettingsJsontextId = this.guid.getGUID(
      "convertsettingsjsontext"
    );
    var convertsettingjsontext = {
      id: this.convertSettingsJsontextId,
      convertsettingid: this.convertSettingId,
      convertsettingname: this.convertSettingName,
      jsontext: {},
    };

    //push metaprofilelayout to request data (postoption)
    postOption.data.convertsettingsjsontext.push(convertsettingjsontext);

    console.log(postOption);

    this.isLoading = true;
    this.dataService.upsertConvertionObjectField(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("/home/convertsettinglist");
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
